import styled from 'styled-components';

import { theme } from '@notino/react-styleguide';

export const Container = styled.div`
  max-width: 64.6875rem;
  margin: 0 auto;
`;

export const StyledHeader = styled.div`
  text-align: center;
  width: 100%;
  margin-top: 2.1875rem;
  margin-bottom: 1.4375rem;
  a {
    color: ${theme.color.text.primary};
    font-weight: bold;
  }
`;
export const StyledHeaderText = styled.h1`
  font-size: 2rem;
  text-align: center;
  font-weight: 300;
  text-transform: none !important;
`;
export const StyledLoginInfoText = styled.div`
  padding: 1rem 0;
`;

export const StyledEmptyInfo = styled.p`
  padding: 1rem;
`;

export const ButtonWrapper = styled.div`
  text-align: center;
  margin-top: 1.875rem;
`;

export const LoadingContainer = styled.div`
  min-height: 20rem;
`;

export const WishlistContainer = styled.div`
  margin-bottom: 2.15rem;
`;

export const Spacer = styled.div<{ isSmall: boolean }>`
  margin-bottom: ${({ isSmall }) => (isSmall ? '5rem' : '10rem')};
`;
